import { createContext, useContext } from 'react';

export const AccountInvoiceBalanceListContext = createContext({
  appliedFilters: {},
  data: [],
});

export const useAccountInvoiceBalanceListContext = () => useContext(AccountInvoiceBalanceListContext);
